import { Menu } from '@material-ui/core';
import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONT_FAMILY } from 'utils/styles/fonts';

export const StyledFlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  cursor:pointer;
  grid-gap: 9px;
`;

export const StyledImageContainer = styled.img``;

export const StyledFlexModalContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn}
  padding: 10px 21px 20px ;
  grid-gap: 16px;
  align-items: flex-start;
`;

export const StyledModalText = styled.div`
  color:${COLORS.mainColor};
  cursor: pointer;
`;

export const StyledMenu = styled(Menu)`
.MuiPaper-root{
  top:50px !important;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  box-shadow: unset;
  background: ${COLORS.multiGray};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  ul{
    padding: 0;
  }
}
`;
export const StyledContainer = styled.div``;

export const StyledLanguageTitle = styled.div`
  ${FONT_FAMILY.FontRegular}
  color:${COLORS.mainColor}
`;
